import styled from "styled-components"
import Colors from "utils/Colors"

export const Button = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem 0.75rem;
  border: none;
  background-color: ${Colors.white};
  color: ${Colors.loginPrimaryColor};
  border-radius: 2px;
  font-weight: 600;
  font-size: 1.5rem;
  width: 100%;
  border-top: solid 1px ${Colors.lightGray};
  
  &:last-child {
    border-bottom: solid 1px ${Colors.lightGray};
  }
  
  & span.label{
    text-transform: capitalize;
    cursor: pointer;
    &:hover{
      text-decoration: underline
    }
  }
  
  &.selected{
    background-color: ${Colors.white};
    color: ${Colors.loginPrimaryColor};
    font-weight: 700;
    cursor: default;
  }
`
